import { createActionCreator } from 'deox';

export const resetActions = {
  reset: createActionCreator('RESET_ACTION', (resolve) => (actionName: string) =>
    resolve({ actionName }),
  ),
};
